import Vue from "vue";

const _alert = {
  show(option) {
    return Vue.swal(option);
  },
  error(err, title = null, text = null, toast = false, icon = null) {
    return Vue.swal({
      position: "center",
      icon: icon || "error",
      title: title || "Error",
      text: toast ? '' : text || (err && err.data ? err.data.message : (err || 'Error')),
      toast: toast,
      position: toast ? "top-right" : "center",
      timer: 3000,
      showConfirmButton: false,
      didOpen: () => {
        Vue.swal.hideLoading()
      },
    });
  },
  warning(err, title = null, text = null, toast = false, icon = null) {
    return Vue.swal({
      position: "center",
      icon: icon || "warning",
      title: title || "Warning",
      text: toast ? '' : text || (err && err.data ? err.data.message : (err || 'Warning')),
      toast: toast,
      position: toast ? "top-right" : "center",
      timer: 3000,
      showConfirmButton: false,
      didOpen: () => {
        Vue.swal.hideLoading()
      },
    });
  },
  success(title = null, text = null, position = "top-right") {
    return Vue.swal({
      position: position,
      icon: "success",
      title: title || text,
      // text: text,
      toast: true,
      timer: 3000,
      showConfirmButton: false,
      timerProgressBar: true,
      didOpen: (toast) => {
        Vue.swal.hideLoading();
        toast.onmouseenter = Vue.swal.stopTimer;
        toast.onmouseleave = Vue.swal.resumeTimer;
      }
    });
  },
  confirm(title = null, text = null, agree = null, disagree = null,agreeColor = null, disagreeColor = null) {
    return Vue.swal({
      title: title,
      text: text,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      showCloseButton: true,
      confirmButtonColor: agreeColor || "#ffc107",
      cancelButtonColor: disagreeColor || "#868e96",
      confirmButtonText: agree || "Ya, Lanjutkan",
      cancelButtonText: disagree || "Batalkan",
      didOpen: () => {
        Vue.swal.hideLoading()
      },
    });
  },
  confirmWithDeny(title = null, text = null, agree = null, disagree = null, agreeColor = null, denyColor = null) {
    return Vue.swal({
      title: title,
      text: text,
      icon: "warning",
      showDenyButton: true,
      showCancelButton: true,
      allowOutsideClick: false,
      showCloseButton: true,
      confirmButtonColor: agreeColor || "#ffc107",
      cancelButtonColor: "#d4d4d4",
      denyButtonColor: denyColor || "#f44336",
      confirmButtonText: agree || "Ya, Lanjutkan",
      denyButtonText: disagree || "Batalkan",
      cancelButtonText: 'Kembali'
    });
  },
  loading(html = null, toast = null) {
    return Vue.swal({
      title: toast ? (html || 'Memuat ...') : '',
      toast: toast || false,
      position: toast ? "top-right" : "center",
      allowOutsideClick: false,
      showCloseButton: false,
      html: toast ? '' : (html || 'Memuat ...'),
      didOpen: () => {
        Vue.swal.showLoading()
      },
    })
  }
};

export default _alert;



// WEBPACK FOOTER //
// ./src/utils/alert.js